import React, { useState, useEffect, useRef } from 'react';
import { motion } from 'framer-motion';

// Import section components
import Header from './Header';
import HeroSection from './HeroSection';
import ServicesSection from './ServicesSection';
import TestimonialsSection from './TestimonialsSection';
import RecentPosts from './RecentPosts';
import CTASection from './CTASection';
import Footer from './Footer';

// Import data
import { services, testimonials, stats } from '../data/landingPageData';

const LandingPage = ({ isMenuOpen, setIsMenuOpen }) => {

  return (
    <div className="min-h-screen bg-slate-900 text-white">
      <Header isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} />
      
      <HeroSection stats={stats} />
      
      <ServicesSection
        services={services}
        OptimizedSpotlightGroup={OptimizedSpotlightGroup}
        OptimizedGradientCard={OptimizedGradientCard}
      />
      
      <TestimonialsSection
        testimonials={testimonials}
        services={services}
        OptimizedSpotlightGroup={OptimizedSpotlightGroup}
        OptimizedGradientCard={OptimizedGradientCard}
      />
      
      <RecentPosts />
      
      <CTASection />
      
      <Footer />
    </div>
  );
};

// Optimized Spotlight Group Component
const OptimizedSpotlightGroup = ({ children }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const cards = container.querySelectorAll('.spotlight-card');

    const handleMouseMove = (e) => {
      const rect = container.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;

      cards.forEach((card) => {
        const cardRect = card.getBoundingClientRect();
        const containerRect = container.getBoundingClientRect();
        const cardX = cardRect.left - containerRect.left;
        const cardY = cardRect.top - containerRect.top;
        
        const relativeX = x - cardX;
        const relativeY = y - cardY;
        
        card.style.setProperty('--mouse-x', `${relativeX}px`);
        card.style.setProperty('--mouse-y', `${relativeY}px`);
      });
    };

    container.addEventListener('mousemove', handleMouseMove);
    container.classList.add('spotlight-group');

    return () => {
      container.removeEventListener('mousemove', handleMouseMove);
      container.classList.remove('spotlight-group');
    };
  }, []);

  return (
    <div ref={containerRef} className="spotlight-group">
      {children}
    </div>
  );
};

// Static Card Component - No animations
const OptimizedGradientCard = ({ children, index }) => {
  return (
    <div className="gradient-border rounded-3xl">
      {children}
    </div>
  );
};


export default LandingPage;
